<template>
  <section class="app-main">
    <router-view v-slot="{ Component }">
      <transition name="fade-transform">
        <component :is="Component" />
      </transition>
    </router-view>
  </section>
</template>

<script setup>

</script>

<style lang="scss" scoped>
*{
  margin: 0;
  padding: 0;
}
.app-main {
  width: 100%;
  // 隐藏横向滚动条但保留滚动功能
  overflow-x: hidden;
  font-size: 0;
  line-height: 0;
  >*{
    line-height: normal;
    font-size: .17rem;
  }
}
:deep(html),
:deep(body) {
  overflow-x: hidden;
  // 对于Webkit浏览器（Chrome、Safari等）的滚动条样式
  scrollbar-width: none; // Firefox
  -ms-overflow-style: none; // IE and Edge
}

// Webkit浏览器的滚动条隐藏样式
:deep(html::-webkit-scrollbar),
:deep(body::-webkit-scrollbar),
:deep(.app-main::-webkit-scrollbar) {
  display: none;
}
</style>